import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';


@Pipe({name: 'NA'})

export class NotapplicableComponent implements PipeTransform {

  constructor() { }

  ngOnInit(): void {
  }

  transform(value: string): string {
    let newStr: string = "";
    if(value=='')
    {
        newStr="NA";
    }
    else{
        newStr=value;
    }
    return newStr;
  }

}
